<template>
  <div
    class="content-card d-flex flex-column align-items-start justify-content-between mb-2"
    :class="classes"
    :style="{ borderWidth: status === 'not-completed' ? '4px' : '0', backgroundColor: status === 'not-completed' ? color : ''}"
  >
    <slot />
  </div>
</template>

<script>
import { ligthen_color } from "@/constants/colors";
  export default {
    props: {
      status: {
        type: String,
        default: 'not-completed',
        validator(value) {
          return ['not-completed', 'completed', 'disabled'].indexOf(value) !== -1
        }
      },

      theme: {
        type: String,
        default: 'module',
        validator(value) {
          return ['module', 'nitro', 'challenge', 'theme'].indexOf(value) !== -1
        }
      }
    },

    computed: {
      classes() {
        if (this.status === 'disabled') {
          return 'bg-gray-100 p-3 rounded-lg small text-gray-300 mt-3'
        }

        if (this.status === 'completed') {
          return `rounded-lg bg-${this.theme} p-3 small pointer-on-hover text-white`
        }

        return `border border-4 border-${this.theme} p-3 rounded-lg small text-${this.theme} font-weight-bold`
      },
      color() {
        return ligthen_color;
      },
    }
  }
</script>

<style scoped lang="scss">
  .content-card {
    min-height: 120px;
    a {
      color: inherit !important;
    }
  }

  .content-card + .content-card {
    margin-top: 1rem;
  }

  .border-4 {
    border-width: 4px !important;
  }
</style>
